const dropdownContainers = document.querySelectorAll('.topbar .dropdown-container');

const setDropdownOpen = (container, open, focusButton = false) => {
  const dropdownBtn = container.querySelector('.dropbtn');
  const dropdownContent = container.querySelector('.dropdown-content');

  if (!dropdownBtn || !dropdownContent) return;

  dropdownContent.classList.toggle('show', open);
  dropdownContent.setAttribute('aria-hidden', open ? 'false' : 'true');
  dropdownBtn.setAttribute('aria-expanded', open ? 'true' : 'false');

  if (!open && focusButton) {
    dropdownBtn.focus();
  }
};

const closeOtherDropdowns = (currentContainer) => {
  dropdownContainers.forEach((container) => {
    if (container !== currentContainer) {
      setDropdownOpen(container, false);
    }
  });
};

dropdownContainers.forEach((container) => {
  const dropdownBtn = container.querySelector('.dropbtn');
  const dropdownContent = container.querySelector('.dropdown-content');

  if (!dropdownBtn || !dropdownContent) return;

  dropdownBtn.addEventListener('click', (event) => {
    event.stopPropagation();
    const isOpen = dropdownContent.classList.contains('show');

    closeOtherDropdowns(container);
    setDropdownOpen(container, !isOpen);
  });

  dropdownBtn.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      closeOtherDropdowns(container);
      setDropdownOpen(container, true);
      dropdownContent.querySelector('a')?.focus();
    }
  });

  container.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      setDropdownOpen(container, false, true);
    }
  });

  container.addEventListener('focusout', (event) => {
    if (!container.contains(event.relatedTarget)) {
      setDropdownOpen(container, false);
    }
  });
});

document.addEventListener('click', (event) => {
  dropdownContainers.forEach((container) => {
    if (!container.contains(event.target)) {
      setDropdownOpen(container, false);
    }
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  dropdownContainers.forEach((container) => {
    setDropdownOpen(container, false);
  });
});
